import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InactivityService } from '../../../core/services/inactivity.service';
import { UserFacade } from '../../../core/store/user/user.facade';
import { InactivityModalComponent } from '../inactivity-modal/inactivity-modal.component';
import { InactivityLoggedOutModalComponent } from '../logout-inactivity-modal/logout-inactivity-modal.component';

@Component({
  selector: 'umkt-inactivity-manager',
  standalone: true,
  imports: [
    CommonModule,
    InactivityModalComponent,
    InactivityLoggedOutModalComponent
  ],
  template: `
    <umkt-inactivity-modal
      [isVisible]="inactivityService.showWarning()"
      [remainingSeconds]="inactivityService.warningTimeLeft()"
      (continueSession)="onContinueSession()"
      (logoutNow)="onLogoutNow()">
    </umkt-inactivity-modal>

    <umkt-inactivity-logged-out-modal
      [isVisible]="inactivityService.isLoggedOut()"
      (dismiss)="onDismissLoggedOut()"
      (loginAgain)="onLoginAgain()">
    </umkt-inactivity-logged-out-modal>
  `
})
export class InactivityManagerComponent implements OnInit, OnDestroy {
  inactivityService = inject(InactivityService);
  private userFacade = inject(UserFacade);

  ngOnInit(): void {
    this.userFacade.getUserDetails().subscribe((user: any) => {
      if (user && user.uuid) {
        this.inactivityService.startMonitoring();
      } else {
        this.inactivityService.stopMonitoring();
      }
    });
  }

  ngOnDestroy(): void {
    this.inactivityService.stopMonitoring();
  }

  onContinueSession(): void {
    this.inactivityService.continueSession();
  }

  onLogoutNow(): void {
    this.inactivityService.logoutNow();
  }

  onDismissLoggedOut(): void {
    this.inactivityService.dismissLoggedOutModal();
  }

  onLoginAgain(): void {
    this.inactivityService.dismissLoggedOutModal();
  }
}
